import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return () => {};
  }
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  let rafId;
  const raf = (time) => {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  };
  rafId = requestAnimationFrame(raf);
  return () => {
    cancelAnimationFrame(rafId);
    lenis.destroy();
    lenis = null;
  };
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset: -76, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export function scrollToTop(immediate = false) {
  if (lenis) {
    lenis.scrollTo(0, { duration: immediate ? 0 : 1.4, immediate });
  } else {
    window.scrollTo({ top: 0, behavior: immediate ? "auto" : "smooth" });
  }
}

export function setScrollLock(locked) {
  if (lenis) {
    locked ? lenis.stop() : lenis.start();
  }
  document.body.style.overflow = locked ? "hidden" : "";
}
